import React from 'react';
import styles from 'assets/css/ProgressBar.module.css';

const ProgressBar = (props) => {
    return (
        <div className={`${styles.progressBar} ${styles[props.className]}`}>
            <Filler percentage={props.percentage} />
        </div>
    )
}

const Filler = (props) => {
    return <div style={{width: `${props.percentage}%`}} className={styles.filler} />
}

export default ProgressBar;
